export const sexSelectorValues = [
  // { title: "All", value: "" },
  { title: "Male", value: "male" },
  { title: "Female", value: "female" },
];

export const sizeSelectorValues = [
  // { title: "All", value: "" },
  { title: "Small", value: "small" },
  { title: "Medium", value: "medium" },
  { title: "Large", value: "large" },
];

// https://www.iban.com/country-codes
export const countrySelectorValues = [
  { title: "All", value: "" },
  { title: "Albania", value: "AL" },
];
